export default __webpack_public_path__ + "static/media/SurveyTask.1955b90c.svg";